export const createLegalLoanRepository = (appFetch) => {
    return {
        list(params = {}) {
            return appFetch.get('/api/v1/business/loan/programs', {params});
        },
        details(slug, params = {}) {
            return appFetch.get(`/api/v1/business/loan/programs/${slug}`, {params});
        },
        filters(params = {}) {
            return appFetch.get('/api/v1/business/loan/filters', {params});
        },
        documents(params = {}) {
            return appFetch.get('/api/v1/business/loan/common-documents', {params});
        },
        referenceData(params = {}) {
            return appFetch.get('/api/v1/business/loan/reference-data', {params});
        },
    };
};
